import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useChatAccessMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemUser */
  // const menuItemUser = {
  //   id: "chat-access-user",
  //   title: "User",
  //   url: baseRouteMakerForSuperAdmin(routes.CHAT_ACCESS_USER)
  // };
  // tempMenuGroup.push(menuItemUser);
  /* menuItemUser */

  /* menuItemServiceProvider */
  // const menuItemServiceProvider = {
  //   id: "chat-access-service-provider",
  //   title: "Service Provider",
  //   url: baseRouteMakerForSuperAdmin(routes.CHAT_ACCESS_SERVICE_PROVIDER)
  // };
  // tempMenuGroup.push(menuItemServiceProvider);
  /* menuItemServiceProvider */

  /* menuItemChatConversation */
  const menuItemChatConversation = {
    id: "chat-conversation",
    title: t("Modules.chatConversation.chatConversation"),
    url: baseRouteMakerForSuperAdmin(routes.CHAT_ACCESS_CHAT_CONVERSATION),
  };
  tempMenuGroup.push(menuItemChatConversation);
  /* menuItemChatConversation */

  return tempMenuGroup;
};
